import { Dispatch, SetStateAction, createContext } from "react";
import { FilterBody, FilterProps } from "../../../hooks/filter/typing";

const ActionPlanContext = createContext<{
    filterData: FilterBody
    actionPlanOfStores: boolean
    doNotHaveAcces: boolean
    setActionPlanOfStores: React.Dispatch<React.SetStateAction<boolean>>
    setFilterPayload: Dispatch<SetStateAction<FilterProps>>
    selectedIds: number[];
    setSelectedIds: Dispatch<SetStateAction<number[]>>;
    notSelected: number[];
    setNotSelected: Dispatch<SetStateAction<number[]>>;
    isChecked: boolean;
    setIsChecked: Dispatch<SetStateAction<boolean>>;
}>(Object({}))

export { ActionPlanContext }